<template>
  <div class="z-tipPanel" @click="close">
    <div class="alertPanel">
      {{ title }}
    </div>
  </div>
</template>
<script type="text/babel">

export default {
  props: [],

  data() {
    return {
      title: "", //标题
      time: 3000 //定时默认3秒
    };
  },

  mounted() {
    let { time } = this;

    //表示有定时器
    if (time > 0) {
      this.timeout ? clearTimeout(this.timeout) : "";
      this.timeout = setTimeout(() => {
        this.close();
      }, time);
    }
  },

  methods: {
    close: function () {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  },

  computed: {

  }
};
</script>

<style lang="scss" scoped>
.z-tipPanel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background-color: transparent;
  text-align: center;
}

.alertPanel {
  position: relative;
  top: 30%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px 40px;
  border-radius: 8px;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
  max-width: 500px;
  min-width: 150px;
  display: inline-block;
}

@media (max-width: 768px) {
  .alertPanel{
    max-width: 80%;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/element/tip/Tip.vue